import * as React from 'react';

var CaretDownSolid = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentColor' : _b;
    return (React.createElement("svg", { height: "12", viewBox: "0 0 21 12", width: "23", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            React.createElement("g", { fill: color, fillRule: "nonzero", transform: "translate(-25 -33)" },
                React.createElement("g", { transform: "translate(25 33)" },
                    React.createElement("path", { d: "M5 14.652V-2.652c0-1.199 1.448-1.799 2.294-.951l8.646 8.652a1.346 1.346 0 010 1.902l-8.646 8.652c-.846.848-2.294.248-2.294-.95z", transform: "rotate(90 10.667 6)" }))))));
};

export { CaretDownSolid as default };
//# sourceMappingURL=CaretDownSolid.esm.js.map
